import React from "react";
import _ from "lodash";
import cx from "classnames";
import { connect } from "react-redux";

import icon from "assets/images/wellness-avatar.png";
import useWindowDimensions from "shared/helpers/getWindowDimensions";

const wellnessStyles = {
  height: "100%",
  padding: "20px",
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  justifyContent: "flex-end",
  background: "linear-gradient(165.23deg, #25629d 8.69%, #18154d 100%)"
};

const Wellness = (props) => {
  const { height } = useWindowDimensions();
  const mobile_app = _.get(props, "gameReducer.mobile_app");
  const status = _.get(props, "gameReducer.roomObj.game_state.status");
  const title_text = _.get(props, "paramsReducer.gameObj.title");
  const secondary_text = _.get(props, "paramsReducer.gameObj.text");

  return (
    <div className="smallbites heightFull">
      <div
        className={cx("bingo-content-wrapper", {
          "playing-overflow-scroll": status === "Playing"
        })}
      >
        <div
          style={{
            ...wellnessStyles,
            height: `${mobile_app ? "100%" : height - 60 + "px"}`
          }}
        >
          <img alt="" src={icon} className="wellness-icon" />
          <div className="wellness-bottom-div">
            <h2>{title_text}</h2>
            <p>{secondary_text}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer
});

export default connect(mapStateToProps, null)(Wellness);
